import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component that automatically scrolls to the top of the page
 * AND all layout scroll containers whenever the route changes.
 * This ensures users always start at the top when navigating to a new page.
 */
export function ScrollToTop() {
  const location = useLocation();

  useLayoutEffect(() => {
    // Disable browser's default scroll restoration
    try {
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
    } catch (e) {
      // Ignore if not supported
    }

    const scrollToTop = () => {
      // Scroll window and document
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // Scroll all layout scroll containers (main elements in layouts)
      const scrollContainers = document.querySelectorAll<HTMLElement>("[data-scroll-container]");
      scrollContainers.forEach((container) => {
        container.scrollTop = 0;
        container.scrollLeft = 0;
      });
    };

    // Execute scroll reset multiple times to handle timing issues
    scrollToTop();
    requestAnimationFrame(scrollToTop);
    const timeoutId = setTimeout(scrollToTop, 50);

    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.search, location.hash, location.key]);

  return null;
}
